export const cartBG = {
    "cart": "Количка",
    "couponCode": "Код за отстъпка",
    "couponButton": "Използвай купон",
    "cartTotals": "Общо",
    "completeOrder": "ПОРЪЧАЙ",    
    "continueShopping": "ПРОДЪЛЖИ С ПОРЪЧКАТА",   
    "without": "Без",
    "select": "ИЗБЕРИ",
    "selectSmall": "Избери",
    "addToCart": "Добавено в количката",
    "cartItems": "Артикули в количката",
    "couponDiscount": "Отстъпка от купон",
    "subTotal": "Междинна сума",
    "couponCaption": "Имате ли купон?",
    "new": "НОВО",
    "sale": "ПРОМОЦИЯ",
    "soldOut": "ИЗЧЕРПАНО",
    "couverCaption": "Брой хора",
    "couverPlaceholder": "Въведете брой",
    "couverError": "Моля въведете брой хора и натиснете проверка",

    "couverUnavailableHeader": "Проблем с куверта",

    "couverUnavailable": "Кувертът не можа да бъде добавен в количката. Опитайте отново или уведомете заведението.",
    "add": "ДОБАВИ"
}
